"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Razorpay {
    constructor(options) {
        this.instance = undefined;
        this.options = options;
        if (typeof window !== "undefined")
            this.instance = new window.Razorpay(this.options);
    }
    on(event, cb) {
        if (!this.instance)
            throw new Error(`Razorpay Instance in not ready`);
        this.instance.on(event, cb);
    }
    open() {
        if (!this.instance)
            throw new Error(`Razorpay Instance in not ready`);
        this.instance.open();
    }
}
exports.default = Razorpay;
//# sourceMappingURL=razorpay.js.map